module.exports = __webpack_public_path__ + "static/stephen-fry-1e86b17547d5108c6f1f2224cee6b111.jpg";